import { staticsUrl, soundPath } from "../../config";
import { Subject } from "rxjs";
import { AUDIO_VOL, SOUND_VOL } from "../types";

const audio = new Audio();
const sound = new Audio();
const loop = new Audio();
loop.loop = true;
const failure1 = "failure1.mp3";
const failure2 = "failure2.mp3";
const success1 = "success1.mp3";
const success2 = "success2.mp3";
const finish1 = "finish1.mp3";
const applause1 = "applause1.mp3";
const uuu = "uuu-voices.mp3";
const bgMusic = "bg-music1.mp3";
const timeThreshold = 200; // minimalny czas pomiędzy odtworzeniami audio (prewencja błędów konsoli)
let audioTime = 0;
let soundTime = 0;
let loopTime = 0;

const defaultMedia = {
  play, // odgrywa dźwięk z danego url
  setUrl,
  audioPath,
  getAudioTime,
  setAudioTime,
  getAudioDuration,
  events: {
    playing: new Subject(),
    waiting: new Subject(),
    ended: new Subject(),
    pause: new Subject(),
    timeupdate: new Subject(),
  },
  playSound, // odgrywa dźwięk ze statyków
  pause,
  stop,
  failure: () => playSound(failure1),
  failure2: () => playSound(failure2),
  success: () => playSound(success1),
  success2: () => playSound(success2),
  finish: () => playSound(finish1),
  applause: () => playSound(applause1),
  uuu: () => playSound(uuu),
  bgMusic: () => playLoop(bgMusic),
  stopBgMusic: stopLoop,
};

audio.addEventListener("playing", (ev) => defaultMedia.events.playing.next(ev));
audio.addEventListener("waiting", (ev) => defaultMedia.events.waiting.next(ev));
audio.addEventListener("ended", (ev) => defaultMedia.events.ended.next(ev));
audio.addEventListener("pause", (ev) => defaultMedia.events.pause.next(ev));
audio.addEventListener("timeupdate", (ev) =>
  defaultMedia.events.timeupdate.next(ev)
);

function play(url = "") {
  if (url && setUrl(url)) {
    audio.play().catch(() => console.log("cannot play file: ", url));
    return;
  }
  if (audio.src) {
    audio.play().catch(() => console.log("cannot play file: ", audio.src));
  }
}

function playLoop(file = "") {
  const time = timestamp();
  if (time - loopTime < timeThreshold) return;
  loopTime = time;
  const url = soundPath(file);
  if (loop.src !== url) loop.src = url;
  if (loop.src) loop.play().catch(() => console.log("cannot play file"));
}

function setUrl(url) {
  const time = timestamp();
  if (time - audioTime < timeThreshold) return false;
  audioTime = time;
  if (audio.src !== url) audio.src = url;
  return true;
}

function getAudioTime() {
  return audio.currentTime;
}

function setAudioTime(time) {
  audio.currentTime = time;
}

function getAudioDuration() {
  return audio.duration;
}

function audioPath(path) {
  return staticsUrl + path;
}

function playSound(file) {
  const time = timestamp();
  if (time - soundTime < timeThreshold) return;
  soundTime = time;
  const url = soundPath(file);
  if (sound.src !== url) sound.src = url;
  if (sound.src) sound.play().catch(() => console.log("Cannot play file"));
}

function pause() {
  audio.pause();
}

function stop() {
  audio.pause();
  audio.currentTime = 0;
}

function stopLoop() {
  loop.pause();
  loop.currentTime = 0;
}

function timestamp() {
  return new Date().getTime();
}

export default function (media = defaultMedia, action) {
  switch (action.type) {
    case AUDIO_VOL:
      audio.volume = action.vol / 100;
      return media;
    case SOUND_VOL:
      sound.volume = action.vol / 100;
      loop.volume = action.vol / 100;
      return media;
    default:
      return media;
  }
}
